import React from "react";
import CountUp from "react-countup";
import './Customers.css';

export default function Counter({ number, title, subtitle, decimals }) {
  return (
    <div className="row">
        <div className="col-lg-12 col-md-12 col-xs-12 number">
            <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                    <p className="title">{title}</p>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12 d-flex justify-content-center">
                    <CountUp duration={10} className="counter" end={number} /> <span className="counter">{decimals}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-12 col-md-12 col-xs-12">
                    <p className="subTitle">{subtitle}</p>
                </div>
            </div>
        </div>
    </div>
  );
}